import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { useId } from '../hooks';
import Description from './description';
import Error from './error';
import Label from './label';
import RequiredIndicator from './required-indicator';
import { wrapperStyle } from './styles';
function FormField({ children, description, error, inverted = false, label, required = false, requiredIndicator = 'showOptional', size = 'medium', }) {
    const id = useId();
    const fieldId = `form-field-${id}`;
    const errorId = `form-field-error-${id}`;
    const hasError = error != null;
    const element = cloneElement(children, Object.assign(Object.assign(Object.assign(Object.assign({ id: fieldId }, (required && { required })), (inverted && { inverted })), (hasError && {
        'aria-describedby': errorId,
        'aria-errormessage': errorId,
        error: true,
    })), { size }));
    return (_jsxs("div", Object.assign({ css: wrapperStyle({ inverted }) }, { children: [_jsxs(Label, Object.assign({ htmlFor: fieldId, size: size }, { children: [label, _jsx(RequiredIndicator, { indicator: requiredIndicator, isRequired: required, size: size })] })), description != null && (_jsx(Description, Object.assign({ size: size }, { children: description }))), element, hasError && (_jsx(Error, Object.assign({ id: errorId, size: size }, { children: error })))] })));
}
export default FormField;
